import React from "react";
import { CloudOff, AlertTriangle } from "lucide-react";

// Clear badge for offline-captured defects/tickets that are still waiting in the sync queue.
export default function PendingItemBadge({ item }) {
  if (!item?.__pending) return null;
  if (item.__failed) {
    return (
      <span data-testid={`item-failed-${item.id}`} title={item.__error || ""}
        className="inline-flex items-center gap-1 shrink-0 rounded-md bg-red-600 text-white text-[10px] font-semibold px-1.5 py-0.5 shadow-sm">
        <AlertTriangle className="h-3 w-3" />Übertragung fehlgeschlagen
      </span>
    );
  }
  return (
    <span data-testid={`item-pending-${item.id}`} title="Offline erfasst – wird bei Verbindung automatisch übertragen"
      className="inline-flex items-center gap-1 shrink-0 rounded-md bg-amber-500 text-white text-[10px] font-semibold px-1.5 py-0.5 shadow-sm">
      <CloudOff className="h-3 w-3" />Noch nicht übertragen
    </span>
  );
}
